import { Component } from '@angular/core';

import { DevFuncConfirmInterface } from '../../base/confirm/dev-func-confirm.interface';

@Component({
    templateUrl: './policy-pause-confirm.component.html',
    styleUrls: ['../../base/base-config-form.component.css'],
    standalone: false
})
export class PolicyPauseConfirmFormComponent implements DevFuncConfirmInterface {
    allowSubmitCallback: (isAllow: boolean) => void;

    _pauseDuration: number;
    _pauseEndDateTime: Date;

    _actionData: any;
    set actionData(data: any) {
        this._actionData = data;
        this._pauseDuration = this._actionData?.pauseDuration;
        
        if (this._actionData?.pauseDuration) {
            const date = new Date();
            date.setMinutes(date.getMinutes() + this._actionData.pauseDuration);
            this._pauseEndDateTime = date;
            this._actionData.pauseEndDateTime = this._pauseEndDateTime;
        }
    }
}